import { BlindsVerticalIcon } from './BlindsVerticalIcon';

/**
 * author: Google
 * id F57CEB13-5A41-498C-BCF5-D7036E7B1122
 * name blinds-vertical
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blinds-vertical.svg
 * tags
 * - Home Automation 
 */
export const WindowIcon = BlindsVerticalIcon;
export default WindowIcon